import React from 'react';
import { useSelector } from 'react-redux';

import { PlayerProps } from './PlayerProps';

import StyledPlayer from './StyledPlayer';

import getPlayerKit from 'helpers/getPlayerKit';

import { setActiveSelectValue } from 'features/input/thunks';
import { useIntl } from 'react-intl';
import { Position } from '../../enums/position';
import { MatchEventType } from '../../enums/matchEventType';
import {
  selectActiveEventTypeId,
  selectActiveTeamOption,
  selectActiveSelectId,
  selectOwnGoalCheckbox,
  selectSelects,
} from '../../features/input/inputSlice';
import { TeamOption } from '../../enums/teamOption';
import { selectRedCardEvents, selectYellowCardEvents } from '../../features/match/matchSlice';
import YellowCardWithShirtNumber from '../eventIcons/YellowCardWithShirtNumber';
import RedCardWithShirtNumber from '../eventIcons/RedCardWithShirtNumber';
import eventIcons from '../../constants/icons';
import { useAppDispatch } from '../../hooks/hooks';

const Player: React.FC<PlayerProps> = ({ player, kit, away }) => {
  let x = 0,
    y = 0;

  const dispatch = useAppDispatch();
  const activeEventTypeId = useSelector(selectActiveEventTypeId);
  const activeSelectId = useSelector(selectActiveSelectId);
  const activeTeamOption = useSelector(selectActiveTeamOption);
  const selects = useSelector(selectSelects);
  const ownGoal = useSelector(selectOwnGoalCheckbox);
  const redCardEvents = useSelector(selectRedCardEvents);
  const yellowCardEvents = useSelector(selectYellowCardEvents);

  if (!player.startsMatch) {
    return null;
  }

  if (!player.position) return null;

  if (!player.position.x || !player.position.y) {
    const { position } = player;
    if (position.id === Position.KEEPER && away) {
      x = 4;
      y = 7;
    } else if (position.id === Position.KEEPER) {
      x = 4;
      y = 1;
    }
  } else {
    x = player.position.x;
    y = player.position.y;

    // flip
    if (away) {
      x -= 8;
      x = Math.abs(x);

      y -= 8;
      y = Math.abs(y);
    }
  }

  const Kit = getPlayerKit(kit.patternId);
  const playerOutIcon: string = eventIcons[MatchEventType.PLAYER_OFF];
  const intl = useIntl();
  const selectConfirm = intl.formatMessage({ id: 'field.selectConfirm' });

  let redCard = false;
  if (redCardEvents.length > 0) {
    redCardEvents.forEach((matchEvent) => {
      if (matchEvent.person?.id === player.personId) {
        redCard = true;
      }
    });
  }

  let yellowCard = false;
  if (yellowCardEvents.length > 0) {
    yellowCardEvents.forEach((matchEvent) => {
      if (matchEvent.person?.id === player.personId) {
        yellowCard = true;
      }
    });
  }

  let disabled = false;
  if (!activeEventTypeId || activeEventTypeId === MatchEventType.COMMENT) {
    disabled = true;
  } else if (activeSelectId === selects.goalScorer.id && ownGoal) {
    if (activeTeamOption === TeamOption.HOME && !away) {
      disabled = true;
    } else if (activeTeamOption === TeamOption.AWAY && away) {
      disabled = true;
    }
  } else if (activeSelectId === selects.playerOffence.id || activeSelectId === selects.playerPenaltyKeeper.id) {
    if (activeTeamOption === TeamOption.HOME && !away) {
      disabled = true;
    } else if (activeTeamOption === TeamOption.AWAY && away) {
      disabled = true;
    }
  } else if (activeTeamOption === TeamOption.HOME && away) {
    disabled = true;
  } else if (activeTeamOption === TeamOption.AWAY && !away) {
    disabled = true;
  }

  const setPlayer = () => {
    if (!disabled) {
      if (player.currentlyOnTheField) {
        dispatch(setActiveSelectValue(player.personId));
      } else {
        const answer = confirm(player.name + selectConfirm);
        if (answer) {
          dispatch(setActiveSelectValue(player.personId));
        }
      }
    }
  };

  return (
    <StyledPlayer
      style={{
        gridRow: y.toString(),
        gridColumn: x.toString(),
      }}
      onClick={setPlayer}
      className={
        (disabled ? 'disabled ' : '') + (player.currentlyOnTheField && !redCard ? 'onTheField' : 'offTheField')
      }
    >
      {redCard && (
        <div className="redCard">
          <RedCardWithShirtNumber shirtNumber={player.shirtNumber > 0 ? player.shirtNumber.toString() : ''} />
        </div>
      )}
      {yellowCard && (
        <div>
          <YellowCardWithShirtNumber shirtNumber={player.shirtNumber > 0 ? player.shirtNumber.toString() : ''} />
        </div>
      )}
      {!redCard && !yellowCard && !player.currentlyOnTheField && (
        <div className="substituted">
          <img className="icon" src={playerOutIcon} alt="Substituted" />
        </div>
      )}
      {!redCard && !yellowCard && player.currentlyOnTheField && (
        <Kit shirtNumber={player.shirtNumber ? player.shirtNumber : ' '} kit={kit} />
      )}
      <div className="name">{player.shirtName}</div>
    </StyledPlayer>
  );
};

export default Player;
